import { useSalesPortalProspectFinderSupplierHqQuery } from '@/experiences/sales-portal/domain/prospects/screens/prospect-finder/blocs/documents/sales-portal-prospect-finder-supplier-hq.generated';

interface SupplierHqLoaderParams {
  enabled: boolean;
  supplierUUID: string;
}

interface SupplierHqResult {
  coordinates: { latitude: number; longitude: number } | null;
  loading: boolean;
}

// Anchors the map on the supplier's HQ before geolocation resolves.
export const useProspectFinderSupplierHqLoader = ({
  enabled,
  supplierUUID,
}: SupplierHqLoaderParams): SupplierHqResult => {
  const { data, loading } = useSalesPortalProspectFinderSupplierHqQuery({
    fetchPolicy: 'cache-first',
    skip: !enabled,
    variables: { supplierUUID },
  });

  const address = data?.businesses_by_pk?.address;
  if (!address) {
    return { coordinates: null, loading };
  }
  return {
    coordinates: { latitude: address.latitude, longitude: address.longitude },
    loading,
  };
};
